import { Controller } from "@hotwired/stimulus"

// Auto-submits its form when a control changes — drives the account-health index's server-driven
// Client Status / coverage-trend / model-trend filter dropdowns (a plain GET, handled by Turbo).
export default class extends Controller {
  submit() {
    this.element.requestSubmit()
  }
}
